<h2 mat-dialog-title class="text-lg font-bold mb-1">
  {{ data.type == "ORDER" ? "Anular" : "Eliminar detalle" }}
</h2>
<mat-dialog-content class="modal-content">
  <form #updateForm="ngForm" class="grid grid-cols-1 gap-4">
    <mat-form-field class="w-full">
      <mat-label>Motivo de rechazo</mat-label>
      <mat-select
        [formControl]="reasonRejectionControl"
        name="reasonRejectionId"
        [required]="reasonRejectionRequired"
        [disabled]="reasonRejectionDisabled"
      >
        <mat-option
          *ngFor="let reasonRejection of reasonRejectionList"
          [value]="reasonRejection.name"
          class="text-content"
        >
          {{ reasonRejection.name }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="reasonRejectionControl.hasError('required')">
        Este campo es obligatorio.
      </mat-error>
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions class="modal-actions flex">
  <button mat-button mat-dialog-close class="align-left">Cancelar</button>
  <button
    mat-raised-button
    color="warn"
    (click)="openConfirmationDialog()"
    [disabled]="!updateForm.valid || reasonRejectionControl.value == null"
    class="justify-end"
  >
    {{ data.type == "ORDER" ? "Anular" : "Eliminar" }}
  </button>
</mat-dialog-actions>

<ng-template #orderConfirmationDialog let-data>
  <div class="flex items-start space-x-2 mb-4">
    <div class="flex items-center">
      <mat-icon
        svgIcon="heroicons_outline:exclamation-triangle"
        class="text-yellow-500 ml-4 mt-6"
        style="font-size: 32px"
      ></mat-icon>
    </div>
    <div class="grid">
      <h2 mat-dialog-title class="text-lg font-bold mb-1">
        {{
          data.type == "ORDER" ? "Confirmar anulación" : "Confirmar eliminación"
        }}
      </h2>
      <mat-dialog-content class="modal-content mt-0">
        <p>
          ¿Está seguro que desea
          {{ data.type == "ORDER" ? "anular" : "eliminar el detalle" }}?
        </p>
      </mat-dialog-content>
    </div>
  </div>
  <mat-dialog-actions class="modal-actions flex justify-end">
    <button mat-button mat-dialog-close class="align-left">Cancelar</button>
    <button mat-raised-button color="warn" [mat-dialog-close]="true">
      Aceptar
    </button>
  </mat-dialog-actions>
</ng-template>
